import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StarComponent } from './star-component';
import { ConfirmComponent } from './confirm.component';
import { AuthHttp } from '../core/auth-http.service';
import { SafeHtmlPipe } from './safeHTML.pipe';

@NgModule({
  imports: [ CommonModule, FormsModule],
  declarations: [StarComponent, ConfirmComponent, SafeHtmlPipe],
  exports: [StarComponent, ConfirmComponent, SafeHtmlPipe],
  providers: [AuthHttp]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared-components/shared.module.ts